import { Component, OnInit, ViewChild, ViewEncapsulation, TemplateRef, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { FocusMonitor } from '@angular/cdk/a11y';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';
import * as moment from 'moment';
import * as AWS from "aws-sdk";

function ValidateEmail(control: AbstractControl): { [key: string]: Boolean } | null {

  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;

  if (control.value !== undefined && !regularExp.test(control.value)) {
    return { "isValidEmail": true };
  }
  return null;
}


// declare var particlesJS: any;
declare var $: any;
import * as AOS from 'aos';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HomeComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
  // form: FormGroup;
  submittedSub = false;
  subscribeForm: FormGroup;
  demoSubmitted = false;
  demoForm: FormGroup;
  public message: any;
  cilentIPAddress = '';
  pdfPath: any;
  currentRoutePath: any;
  videoUrl: any;
  constructor(private route: ActivatedRoute, public fb: FormBuilder, private http: HttpClient, public router: Router, private httpService: HttpService, private domSanitizer: DomSanitizer) {
    this.currentRoutePath = this.router.url;

    var that = this;
    that.videoUrl = that.domSanitizer.bypassSecurityTrustResourceUrl('');
    $('#playVideoHome').on('hidden.bs.modal', function () {
      that.videoUrl = that.domSanitizer.bypassSecurityTrustResourceUrl('');
    })

    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: [''],
    });
  }

  API_URL = environment.API_URL;
  public send_email(httpService: HttpService) {
    httpService
      .sendPostRequest('abc@abc.com')
      .subscribe((responseBody: any) => {
      });
  }
  get getSubForm() {
    return this.subscribeForm.controls;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }

  submitForm() {
    const headerDict = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Access-Control-Allow-Headers': '*',
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.submittedSub = true;
    if (this.subscribeForm.invalid) {
      return;
    } else {
      var email = JSON.stringify(this.subscribeForm.value);
      this.http.post(this.API_URL, email, requestOptions).subscribe(
        (response: any) => {
          this.message = response.message;
          alert(this.message);
        },
      );
      this.submittedSub = false;
    }
  }

  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }
  subRespData: any;

  submitSubForm() {
    let url = environment.API_URL + "subscribe";
    // let url = "https://dev.website.protectt.ai/Webapi/email/subscribe";
    let urlValue = "";
    this.submittedSub = true;
    if (this.subscribeForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      let subData = {
        email: this.subscribeForm.value['email'],
        ipaddress: this.cilentIPAddress,
        weburl: urlValue
      }
      let data = {
        subscriptionData: subData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }


      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

    }
  }

  submitDemoForm() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: '',
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          if (resp['statusDesc'] === 'Your Data Saved Successfully') {
            alert('Thank you for reaching out to us for your Mobile App Security requirements. Our Cyber Security Expert will contact you shortly.');
          }

          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }
  s3: any;
  getMainContentTrusted(value: any) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }


  testimonial = [
    //  {
    //    img: "assets/images/new/shivkumar.webp",
    //    content: "AppProtectt Mobile App RASP security helped us to enhance our Mobile App Security with quick implementation and also provided visibility into threats and prevention on real-time.  Now, our team can focus more on App Features development while AppProtectt is adding a layer of security for our mobile apps.",
    //    name: "Shivkumar Pandey",
    //   designation: "Group CISO",
    //   designation2: "Bombay Stock Exchange"
    // },
    // {
    //   img: "assets/images/new/nilesh_sangoi.webp",
    //   content: "AppProtectt helped us achieve high standards of Mobile Banking App security and fraud control for our customers. It also helped in complying with RBI’s digital payment security master direction specific to Mobile Banking and a quick Go-to-Market.",
    //   name: "Nilesh Sangoi",
    //   designation: "Chief Information Officer",
    //   designation2: "Fincare Small Finance Bank"
    // },
  ];

  //testimonialslide = { "slidesToShow": 3, "slidesToScroll": 1, "autoplay": true, "autoplaySpeed": 4000, "dots": true, prevArrow: null, nextArrow: null, focusOnSelect: true, centerMode: true, centerPadding: 0};

  testimonialslide = {
    "slidesToShow": 2, "slidesToScroll": 1, "autoplay": true, "autoplaySpeed": 4000, "dots": true, prevArrow: null, nextArrow: null, focusOnSelect: true, centerMode: true, centerPadding: 0,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,

      }

    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        centerMode: true,

      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
      }
    }]
  };


  slides = [
    {
      index: 6,
      img: "assets/images/slider/award23.webp" ,
      title: this.domSanitizer.bypassSecurityTrustHtml("Protectt.ai wins <br><span style='font-weight: 900'>Security Product <br> Company of the Year 2023</span>"),
      titlemobile: this.domSanitizer.bypassSecurityTrustHtml("Protectt.ai wins <br><span style='font-weight: 600'>Security Product Company<br>  of the Year 2023</span>"),
      desc: this.domSanitizer.bypassSecurityTrustHtml("Leader in Mobile App Security in India"),
      //descmobile: this.domSanitizer.bypassSecurityTrustHtml("Leader in Mobile App Security in India"),
      subdesc: this.domSanitizer.bypassSecurityTrustHtml("Banking | Insurance | NBFC | Government"),
      // desc: "AppProtectt: Innovative Runtime Application Self Protection Enabled SDK",
      link: "/appprotectt",
      button1: "Request a Demo",
      button2: "Learn More"
    },
    {
      index: 1,
      img: "assets/images/slider/enhance_your_mobile_app_security.webp",
      title: this.domSanitizer.bypassSecurityTrustHtml("Enhance Your Mobile App Security<br><span style='font-weight: 600'>Effortlessly</span>"),
      titlemobile: this.domSanitizer.bypassSecurityTrustHtml("Enhance Your Mobile App <br>Security<span style='font-weight: 600'>Effortlessly</span>"),
      desc: this.domSanitizer.bypassSecurityTrustHtml("Leader in Mobile App Security in India"),
      //descmobile: this.domSanitizer.bypassSecurityTrustHtml("Leader in Mobile App Security in India"),
      subdesc: this.domSanitizer.bypassSecurityTrustHtml("Banking | Insurance | NBFC | Government"),
      // desc: "AppProtectt: Innovative Runtime Application Self Protection Enabled SDK",
      link: "/appprotectt",
      button1: "Request a Demo",
      button2: "Learn More"
    },
    {
      index: 2,
      img: "assets/images/slider/customer-excellence.webp",
      title: "Customer Excellence Awards",
      titlemobile: "Customer Excellence Awards",
      
      desc: "Protectt.ai is honored to be the Trusted Mobile<br>App Security Partner for India's leading BFSI giants",
      link: "",
      button1: "Request a Demo",
      button2: ""
    },
    {
      index: 3,
      img: "assets/images/slider/solution_for_digital_payments_security.webp",
      title: this.domSanitizer.bypassSecurityTrustHtml("Solution for Digital Payments Security Controls for <span style='font-weight: 600'>Mobile Banking Apps</span>"),
      titlemobile: "Solution for Digital Payments Security Controls for Mobile Banking Apps",
      desc: this.domSanitizer.bypassSecurityTrustHtml("A Leader in Mobile App Security in India"),
      descmobile: this.domSanitizer.bypassSecurityTrustHtml(""),
      subdesc: this.domSanitizer.bypassSecurityTrustHtml("Banking | Insurance | NBFC | Government"),
      link: "/rbi-digital-payment-security-control-solution",
      button1: "Request a Demo",
      button2: "Learn More"
    },
    {
      index: 3,
      img: "assets/images/slider/app_bind.webp",
      title: "AppBind: Zero Trust DEVICE & SIM Binding For Mobile Banking Apps",
      titlemobile: "<strong>AppBind :</strong> Zero Trust DEVICE & SIM Binding For Mobile Banking Apps",
      desc: "Advance Mobile Device Binding Technique For Safe Mobile Banking Experience ",
      link: "/appbind",
      button1: "Request a Demo",
      button2: "Learn More"
    },
    {
      index: 4,
      img: "assets/images/slider/protect_your_mobile.webp",
      title: "Protect Your Banking Mobile Apps From Emerging Malware Threats",
      titlemobile: "Protect Your Banking Mobile Apps From Emerging Malware Threats",
      desc: "",
      link: "/appprotectt",
      button1: "Request a Demo",
      button2: "Learn More"
    },

    // {
    //   index: 5,
    //   img: "assets/images/slider/mprotectt.webp",
    //   title: "MProtectt: Your Mobile Privacy Guard",
    //   titlemobile: "<strong>MProtectt :</strong> Complete security for your mobile device",
    //   desc: "Enhanced Security Against Stealthy Malware, Harmful Apps And Mobile Banking Threats",
    //   link: "/mprotectt",
    //   button1: "Request a Demo",
    //   button2: "Learn More"
    // },

    // {
    //   index: 6,
    //   img: "assets/images/slider/cyber_lab_services.webp",
    //   title: "Cyber Lab Services",
    //   titlemobile: "<strong>Cyber Lab Services :</strong> Enhanced protection against cyber issues related to organisational processes, data and infrastructure",
    //   desc: "Helps Organizations To Enhance Protection Against Cyber Issues Related To Processes, Data And Infrastructure",
    //   link: "/cyber-lab-services",
    //   button1: "Request a Demo",
    //   button2: "Learn More"
    // },
    // {
    //   index: 5,
    //   img: "assets/images/slider/cover_emplyee.webp",
    //   title: "Protectt.ai wins <br/> DSCI INNOVATION BOX AWARD 2023",
    //   titlemobile: "Protectt.ai wins <br/> DSCI INNOVATION BOX AWARD 2023",
    //   desc: '<strong>"AppProtectt" Mobile App Security Platform</strong>',
    //   link: "/press-release-dsci-finsec-award",
    //   button1: "",
    //   button2: "Read More"
    // },
  ];

  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1, "autoplay": true, "autoplaySpeed": 40000, "dots": true, prevArrow: null, nextArrow: null };


  addSlide() {
    //this.slides.push({img: "http://placehold.it/350x150/777777"})
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() {
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  testimonialInit() {
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  breakpoint() {
  }

  afterChange() {
    this.slickInit()
    this.testimonialInit()
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
    //$(".bnrcontent").css("visibility", "visible");
    $(".bnrcontent").css("transform", "translateZ(0)");
    $(".bnrcontent").css("transition-duration", "3s");

  }


  beforeChange() {
    //$(".bnrcontent").css("visibility", "hidden");
    $(".bnrcontent").css("transform", "translate3d(100px,0,0)");
    $(".bnrcontent").css("transition-duration", "3s");
  }
  mobile = false;

  ngOnInit() {
    $('#homepopup').modal('show');

    var that = this;
    $('#playVideoHome').on('hidden.bs.modal', function (e: any) {
      that.videoUrl = that.domSanitizer.bypassSecurityTrustResourceUrl('');
    })
    this.route.queryParams.subscribe(params => {
      if(params['action'] === 'request_demo') {
        this.showDemoPopup();
      }
    });

  }

  showMediaPopup() {
    $('#mediaimagepopup').modal('show');
  }
  showDemoPopup() {
    $('#modalContactForm').modal('show');
  }


  onClickPdfView(filename: any, field: any) {
    let AKey;
    let SKey;
    let url = environment.API_URL + "fetchbucketcred"
    this.httpService.getAPI(url).then((resp: any) => {
      // console.log(resp);
      let decRes = this.httpService.decryptText(resp, HttpService.SECRET_KEY);
      let decMsg = JSON.parse(decRes);
      // console.log(decMsg?.lkpList);
      // console.log(decMsg?.lkpList[0].lkpvalue);
      // console.log(decMsg?.lkpList[1].lkpvalue);

      AKey = decMsg?.lkpList[0].lkpvalue;
      SKey = decMsg?.lkpList[1].lkpvalue;


      AWS.config.update({
        accessKeyId: AKey,
        secretAccessKey: SKey,
        region: "ap-south-1",
      });
      this.s3 = new AWS.S3();
      // console.log(this.s3);
      setTimeout(() => {
        let logo = "datasheets/" + filename;

        const url = this.s3.getSignedUrl("getObject", {
          Bucket: environment.Bucket,
          Key: field == 'video' ? filename : logo,
          Expires: 60,
        });

        if (field == 'video') {
          this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url || '');
        } else {
          this.pdfPath = url;
          window.open(this.pdfPath, "_blank");
        }
      }, 500);

    })
  }

  ngOnDestroy(): void {
    $('#mediaimagepopup').modal('hide');
  }
}
